import React, { useState } from "react";
import styled from "styled-components";

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { ReactComponent as CheckSvg } from '../../image/Check.svg';


export default function TeacherBox(props) {
  const { data, index, isLast, isClicked, onClickTeacherBox } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);

  function decideFontColor() {
    if (isHover) return theme.subBackground;
    else if (isClicked) return theme.primary;
    else return theme.text;
  }

  return (
    <TeacherBoxView
      key={'Teachers-' + index}
      isLast={isLast}
      isHover={isHover}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onClickTeacherBox(data)}>
      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={decideFontColor()} cursor='pointer'>{data.teacherName}</Text>
      <StyledCheck $isHover={isHover} $isClicked={isClicked} />
    </TeacherBoxView>
  )
}


const TeacherBoxView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);
  min-height: ${props => props.isLast ? `32px` : `31px`};

  border-bottom: ${props => props.isLast ? `0px` : `1px solid ${props.theme.line}`};
  background-color: ${props => props.isHover ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledCheck = styled(CheckSvg)`
  flex-shrink: 0;
  width: 12px;
  height: auto;

  opacity: ${props => props.$isClicked ? 1 : 0};

  & path {
    fill: ${props => props.$isHover ? props.theme.subBackground : props.theme.primary};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;